import { useState } from "react";
import { Download } from "lucide-react";
import { Logo } from "./Logo";
import { PolicyDialog } from "./PolicyDialog";
import { openBrochureModal } from "./BrochureModal";
import { CONTACTS } from "@/data/apartments";
import { track } from "@/lib/gtag";
import { useLang } from "@/i18n";

export const Footer = () => {
  const { t } = useLang();
  const [policy, setPolicy] = useState(null);

  return (
    <footer className="border-t border-ivory/10 bg-ink pb-10 pt-16 text-ivory" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-6 sm:px-10">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div>
            <Logo markClass="h-11 w-auto" />
            <p className="mt-4 text-xs uppercase tracking-[0.22em] text-ivory/50">{t.footer.tagline}</p>
          </div>
          <div className="text-sm text-ivory/70">
            <p>{CONTACTS.indirizzo}</p>
            <p className="mt-1">
              <a
                href={`tel:${CONTACTS.telefono.replace(/ /g, "")}`}
                onClick={() => track("click_telefono")}
                className="transition-colors hover:text-sun"
                data-testid="footer-phone-link"
              >
                {CONTACTS.telefono}
              </a>{" "}
              — {CONTACTS.email}
            </p>
            <button
              onClick={openBrochureModal}
              data-testid="footer-brochure-link"
              className="mt-3 inline-flex items-center gap-2 text-sun underline underline-offset-4 transition-colors hover:text-ivory"
            >
              <Download className="h-4 w-4" strokeWidth={1.5} />
              {t.brochure}
            </button>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-ivory/60">
            <button onClick={() => setPolicy("privacy")} className="transition-colors hover:text-ivory" data-testid="footer-privacy-link">
              {t.footer.privacy}
            </button>
            <button onClick={() => setPolicy("cookie")} className="transition-colors hover:text-ivory" data-testid="footer-cookie-link">
              {t.footer.cookie}
            </button>
            <a href="/admin/login" className="transition-colors hover:text-ivory" data-testid="footer-admin-link">
              {t.footer.admin}
            </a>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-2 border-t border-ivory/10 pt-6 text-[11px] text-ivory/40 sm:flex-row sm:items-center sm:justify-between">
          <p>{t.footer.rights}</p>
          <p>{t.footer.disclaimer}</p>
        </div>
      </div>
      <PolicyDialog open={!!policy} onOpenChange={(v) => !v && setPolicy(null)} type={policy || "privacy"} />
    </footer>
  );
};
